import React, { useEffect, useState } from "react";
import { Button, Input } from "../ui";
import LudDashboardModal from "./LudDashboardModal";
import { useSubmitGuard } from "./modalHooks";
import { integrationLabel } from "../../utils/integrations";

// Canonical keys; labels come from the registry.
const APPS = ["jahez", "hungerstation", "keeta", "toyou", "marsool", "thechefz", "ninja", "feedus"];
const EMPTY_USER = { app: "jahez", email: "", password: "", status: "active" };

export default function BranchUserModal({ open, lang, onClose, onSave }) {
  // Repeat clicks are ignored while a save returned by the caller is running.
  const [saving, runSave] = useSubmitGuard();
  const [form, setForm] = useState(EMPTY_USER);

  useEffect(() => {
    if (open) setForm(EMPTY_USER);
  }, [open]);

  return (
    <LudDashboardModal
      open={open}
      busy={saving}
      title={lang === "ar" ? "إضافة يوزر للفرع" : "Add Branch User"}
      onClose={onClose}
      footer={
        <>
          <Button variant="neutral" appearance="ghost" onClick={onClose}>{lang === "ar" ? "إلغاء" : "Cancel"}</Button>
          <Button onClick={() => runSave(onSave, form)} disabled={saving} loading={saving}>{lang === "ar" ? "إضافة" : "Add"}</Button>
        </>
      }
    >
      <div className="lud-form-grid">
        <label className="lud-native-field">
          <span>{lang === "ar" ? "التطبيق" : "Application"}</span>
          <select value={form.app} onChange={(event) => setForm((current) => ({ ...current, app: event.target.value }))}>
            {APPS.map((app) => <option key={app} value={app}>{integrationLabel(app, lang)}</option>)}
          </select>
        </label>
        <Input label={lang === "ar" ? "الإيميل" : "Email"} value={form.email} onChange={(event) => setForm((current) => ({ ...current, email: event.target.value }))} />
        <Input label={lang === "ar" ? "الرقم السري" : "Password"} value={form.password} onChange={(event) => setForm((current) => ({ ...current, password: event.target.value }))} />
      </div>
    </LudDashboardModal>
  );
}
